<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.carinoutinfo_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>
<script>
import { add, getDetail, getList, remove, update } from '@/api/v4ward/car/carchargerule';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        sarchShow: true,
        searchMenuSpan: 6,
        calcHeight: 30,
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',
        viewBtn: true,
        selection: true,
        column: [
          {
            label: '车场名称',
            type: 'tree',
            prop: 'spaceId',
            search: true,
            editDisabled: true,
            labelWidth: 120,
            cell: true,
            props: {
              label: 'title',
              value: 'key',
            },
            rules: [
              {
                required: true,
                message: '请输入车场名称',
              },
            ],
            dicUrl: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode?id=0',
          },
          {
            label: '规则名称',
            prop: 'ruleName',
            editDisabled: true,
            labelWidth: 120,
            search: true,
            rules: [
              {
                required: true,
                message: '请输入规则名称',
              },
            ],
          },
          {
            label: '规则编号',
            prop: 'ruleCode',
            labelWidth: 120,
            editDisabled: true,
            rules: [
              {
                required: true,
                message: '请输入规则编号',
              },
            ],
          },
          {
            label: '免费时长(分钟)',
            prop: 'freemins',
            type: 'number',
            labelWidth: 120,
            rules: [
              {
                required: true,
                message: '请输入免费时间(分钟)',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '首段时长(分钟)',
            prop: 'inceptmins',
            type: 'number',
            labelWidth: 120,
            rules: [
              {
                required: true,
                message: '请输入首段时长(分钟)',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '首段金额(元)',
            prop: 'inceptmoney',
            type: 'number',
            labelWidth: 120,
            precision: 2,
            mock: {
              type: 'number',
              max: 1,
              min: 2,
              precision: 2,
            },
            minRows: 0,
            rules: [
              {
                required: true,
                message: '请输入首段金额(元)',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '累积时长(分钟)',
            prop: 'addmins',
            type: 'number',
            labelWidth: 120,
            rules: [
              {
                required: true,
                message: '请输入后续时间(分钟)',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '累加金额(元)',
            prop: 'addmoney',
            type: 'number',
            labelWidth: 120,
            precision: 2,
            mock: {
              type: 'number',
              max: 1,
              min: 2,
              precision: 2,
            },
            minRows: 0,
            rules: [
              {
                required: true,
                message: '请输入后续金额(元)',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '最高金额(元)',
            prop: 'daymoney',
            type: 'number',
            labelWidth: 120,
            precision: 2,
            mock: {
              type: 'number',
              max: 1,
              min: 2,
              precision: 2,
            },
            minRows: 0,
            rules: [
              {
                required: true,
                message: '请输入每天最高收费金额(元)',
                trigger: 'blur',
              },
            ],
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.carchargerule_add, false),
        viewBtn: this.vaildData(this.permission.carchargerule_view, false),
        delBtn: this.vaildData(this.permission.carchargerule_delete, false),
        editBtn: this.vaildData(this.permission.carchargerule_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({
            ids: row.id,
          });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({
            ids: this.ids,
          });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({
          id: this.form.id,
        }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(
        Object.assign(
          {
            current: page.currentPage,
            size: page.pageSize,
          },
          this.query
        )
      ).then(({ data }) => {
        this.page.total = data.total;
        this.data = data.records;
        this.loading = false;
        this.selectionClear();
      });
    },
  },
};
</script>

<style></style>
